import { FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { RootState } from '../store';
import { CutterHistory } from '../types/cutterHistory';

export interface ContractualDataResponse {
    success: boolean;
    data?: string; // JSON serialized string
}

export interface FactoryNetworkResponse {
    nodes: any[];
    edges: any[];
}

export const cutterHistoryApi = createApi({
    reducerPath: 'CutterHistoryApi',
    tagTypes: ['CutterHistory', 'ContractualData', 'FactoryNetwork'],
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.PUBLIC_URL}/api/CutterHistory/`,
        prepareHeaders: (headers, { getState }) => {
            const accessToken = (getState() as RootState).userStateReducer.accessToken;

            if (accessToken !== '') {
                headers.set('authorization', `Bearer ${accessToken}`)
            }

            return headers
        },
    }),
    endpoints: (build) => ({
        getCutterHistoryBySerial: build.query<Map<string, CutterHistory>, string>({
            query: (serialNumber: string) => `LoadHistory?serialNumbers=${serialNumber}`,
            providesTags: ['CutterHistory'],
            transformErrorResponse: (failure: FetchBaseQueryError, meta: FetchBaseQueryMeta) => {
                let returnedError: string = 'An error occured while requesting cutter history';
                switch (failure.status) {
                    case "FETCH_ERROR":
                        break;
                    case "PARSING_ERROR":
                        break;
                    case "TIMEOUT_ERROR":
                        break;
                    case "CUSTOM_ERROR":
                        break;
                }
                returnedError = `${failure.status}  - ${returnedError}`;
                return returnedError;
            }
        }),
        getContractualDataTest: build.query<ContractualDataResponse, string>({
            query: (serialNumber: string) => `ContractualDataTest?serialNumber=${serialNumber}`,
            providesTags: ['ContractualData']
        }),
        getFactoryNetwork: build.query<FactoryNetworkResponse, string>({
            query: (serialNumber: string) => `FactoryNetwork?serialNumber=${serialNumber}`,
            providesTags: ['FactoryNetwork'],
            transformResponse: (response: FactoryNetworkResponse) => {
                // Perform any necessary transformation on the response here
                return response;
            },
            transformErrorResponse: (failure: FetchBaseQueryError, meta: FetchBaseQueryMeta) => {
                let returnedError: string = 'An error occured while requesting cutter network map';
                switch (failure.status) {
                    case "FETCH_ERROR":
                        break;
                    case "PARSING_ERROR":
                        break;
                    case "TIMEOUT_ERROR":
                        break;
                    case "CUSTOM_ERROR":
                        break;
                }
                returnedError = `${failure.status}  - ${returnedError}`;
                return returnedError;
            }
        })
    }),
})

export const { useGetCutterHistoryBySerialQuery, useGetContractualDataTestQuery, useGetFactoryNetworkQuery } = cutterHistoryApi;
